module.exports = __webpack_public_path__ + "static/media/demo.a3b6deab.jpg";